import React, { useState, useEffect } from "react";

// MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { red } from "@mui/material/colors";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

//API
import { API } from "../../config";
import { getAPI } from "../../services/commonService";
import { fni18n } from "../../services/commonService";

//
import { theme } from '../../assets/themes';

const SystemMachineDetailPage = (props) => {
    return (
    <div className="pop-container">
        {/* 상단메뉴명 */}
        <div className="header">
            {fni18n('기종 설정')}
        </div>
        <div className="contents">
        <TableContainer className="table-container" component={Paper} elevation={0}>
            <Table className="table" size="small">
                <TableBody>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('기종번호')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            placeholder="new"
                            name="machKndCd"
                            value={props.data.machKndCd || ""}
                            onChange={e => props.onChange(e)}
                            error={props.showError && props.errors.machKndCd}
                            helperText={props.errors.machKndCd || ""}
                            />
                        </FormControl> 
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('기종명')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            placeholder=""
                            name="machKndNm"
                            value={props.data.machKndNm || ""}
                            onChange={e => props.onChange(e)}
                            error={props.showError && props.errors.machKndNm}
                            helperText={props.errors.machKndNm || ""}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('설명')}</TableCell>
                    <TableCell className="table-cell" >
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            multiline
                            rows={1}
                            value={props.data.machKndDesc || ""}
                            name="machKndDesc"
                            onChange={e => props.onChange(e)}
                            error={props.showError && props.errors.machKndDesc}
                            helperText={props.errors.machKndDesc || ""}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('명세표여부')}</TableCell>
                    <TableCell className="table-cell" >
                        <FormControlLabel
                            control={
                            <Checkbox
                            name="jrnlYn"
                            checked={props.data.jrnlYn === "Y" ? true : false}
                            onChange={e => props.onSwitchChange(e)}
                            />
                        }
                        />
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('지폐부여부')}</TableCell>
                    <TableCell className="table-cell" >
                        <FormControlLabel
                            control={
                            <Checkbox
                            name="billYn"
                            checked={props.data.billYn === "Y" ? true : false}
                            onChange={e => props.onSwitchChange(e)}
                            />
                        }
                        />
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('동전부여부')}</TableCell>
                    <TableCell className="table-cell" >
                        <FormControlLabel
                            control={
                            <Checkbox
                            name="coinYn"
                            checked={props.data.coinYn === "Y" ? true : false}
                            onChange={e => props.onSwitchChange(e)}
                            />
                        }
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('카메라여부')}</TableCell>
                    <TableCell className="table-cell" >
                        <FormControlLabel
                            control={
                            <Checkbox
                            name="cameraYn"
                            checked={props.data.cameraYn === "Y" ? true : false}
                            onChange={e => props.onSwitchChange(e)}
                            />
                        }
                        />
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                    <TableCell className="table-cell" >
                        <FormControlLabel
                            control={
                            <Checkbox
                            name="useYn"
                            checked={props.data.useYn === "Y" ? true : false}
                            onChange={e => props.onSwitchChange(e)}
                            />
                        }
                        />
                    </TableCell>
                    <TableCell className="table-cell" ></TableCell>
                    <TableCell className="table-cell" ></TableCell>
                </TableRow>
                </TableBody>            
            </Table>
        </TableContainer>
        </div>
    </div>
    )
}

export default SystemMachineDetailPage;